export default class ReversedTextareaCounter {
	firstUserInput = [];

	constructor({ elements }) {
		elements.forEach((el, i) => {
			// append counter html to textbox
			if (el.dataset.reversedTextareaCounter > 0) {
				this.firstUserInput[i] = true;
				const { reversedTextareaCounter, counterWithoutError } = el.dataset;
				if (!counterWithoutError && el.dataset.errorMessage) {
					this.errorMessage = el.dataset.errorMessage;
					el.insertAdjacentHTML(
						'afterend',
						`<div class="counter-container"><div class="textarea-counter">-${reversedTextareaCounter}</div>
						<div class="counter__error-message hide">${this.errorMessage}</div></div>`
					);
				} else {
					el.insertAdjacentHTML(
						'afterend',
						`<div class="counter-container flex flex--self-end"><div class="textarea-counter textarea-counter--alt">${reversedTextareaCounter}</div>`
					);
				}
				// wire up listener
				el.addEventListener('keyup', (e) => {
					const maxCharacters = e.target?.dataset.reversedTextareaCounter;
					const characters = e.target?.value?.length;
					this.validate({
						el,
						target: e.target,
						maxCharacters,
						characters,
						textareaCounter: reversedTextareaCounter,
						counterWithoutError,
						elementIndex: i,
					});
				});
				el.addEventListener('focusout', (e) => {
					const maxCharacters = e.target?.dataset.reversedTextareaCounter;
					const characters = e.target?.value?.length;
					this.validate({
						el,
						target: e.target,
						maxCharacters,
						characters,
						textareaCounter: reversedTextareaCounter,
						counterWithoutError,
						elementIndex: i,
					});
				});
			}
		});
	}

	validate({
		target,
		maxCharacters,
		characters,
		textareaCounter,
		counterWithoutError,
		elementIndex,
	}) {
		const counter = target.nextSibling.childNodes[0];

		if (!counterWithoutError) {
			const errorMessageBox = target.nextSibling.childNodes[2];
			counter.innerHTML = characters - textareaCounter;
			if (characters < maxCharacters && !this.firstUserInput[elementIndex]) {
				ReversedTextareaCounter.incorrectInput(counter, errorMessageBox);
			}
			if (characters >= maxCharacters) {
				ReversedTextareaCounter.correctInput(counter, errorMessageBox);
				this.firstUserInput[elementIndex] = false;
				counter.innerHTML = '<span>&#10004;</span>';
			}
		}
	}

	static correctInput(counter, errorMessageBox) {
		counter.classList.remove('textarea-counter__error');
		counter.classList.add('textarea-counter__success');
		errorMessageBox.classList.add('hide');
	}

	static incorrectInput(counter, errorMessageBox) {
		counter.classList.add('textarea-counter__error');
		counter.classList.remove('textarea-counter__success');
		errorMessageBox.classList.remove('hide');
	}
}
